import { render, staticRenderFns } from "./newsletter-list-page.vue?vue&type=template&id=3d3d99cd&"
import script from "./newsletter-list-page.vue?vue&type=script&lang=js&"
export * from "./newsletter-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports